export default __webpack_public_path__ + "static/0163-2d84e9d9157e1787237573824d0a6cc1.png";